"use client";

import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

import NewsPage from "./NewsPage";
import { newsPageQuery } from "@otomoro/sanity/lib/queries";

type NewsPagePreviewProps = {
  initial: QueryResponseInitial<SanityDocument[]>
  searchParams: { [key: string]: string}
}

export default function NewsPagePreview({
  initial,
  searchParams,
}: NewsPagePreviewProps) {
	const { data } = useQuery<SanityDocument[] | null>(
    newsPageQuery,
    {
     lastPublishedAt: searchParams.lastPublishedAt || null,
     newsType: searchParams["categories"] ? searchParams["categories"] : null,
    },
    { initial }
  );

	return data ? (
    <NewsPage data={data as any} nextArticles={[]} searchParams={searchParams} />
  ) : (
    <div className="bg-red-100">No posts found</div>
  );
}
